import { render, staticRenderFns } from "./LazySelect.vue?vue&type=template&id=35ba70f5&"
import script from "./LazySelect.vue?vue&type=script&lang=js&"
export * from "./LazySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports